/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-12 10:42:52
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-22 09:52:33
 */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../../../app/store'
import { dentalLedgerDelete, DentalLedgerDeleteParams, dentalLedgerProcessDetail, DentalLedgerProcessDetailParams, dentalLedgerProcessList, DentalLedgerProcessListParams, dentalLedgerSubmit, DentalLedgerSubmitParams, DoctorAuditEntriesDetailParams, DoctorAuditEntriesParams, getDoctorAuditEntries, getDoctorAuditEntriesDetail, getDoctorAuditEntriesListExport } from '../../../../services/dentureLedgerPage'

// 列表
export const getDoctorAuditEntriesList = createAsyncThunk<
  void,
  DoctorAuditEntriesParams,
  RootThunkApi
>('payment/getTransactionQueryList', async (params, api) => {
  return sendAsync(getDoctorAuditEntries(params), api)
})

// 详情
export const getDoctorAuditEntriesDetailAsync = createAsyncThunk<
  void,
  DoctorAuditEntriesDetailParams,
  RootThunkApi
>('payment/getDoctorAuditEntriesDetailAsync', async (params, api) => {
  return sendAsync(getDoctorAuditEntriesDetail(params), api)
})

// 保存
export const getDentalLedgerSubmitAsync = createAsyncThunk<
  void,
  DentalLedgerSubmitParams,
  RootThunkApi
>('dentalLedgerSubmitAsync', async (params, api) => {
  return sendAsync(dentalLedgerSubmit(params), api)
})

// 关联外加工
export const getDentalLedgerProcessListAsync = createAsyncThunk<
  void,
  DentalLedgerProcessListParams,
  RootThunkApi
>('dentalLedgerProcessListAsync', async (params, api) => {
  return sendAsync(dentalLedgerProcessList(params), api)
})

// 外加工详情
export const getDentalLedgerProcessDetailAsync = createAsyncThunk<
  void,
  DentalLedgerProcessDetailParams,
  RootThunkApi
>('dentalLedgerProcessDetailAsync', async (params, api) => {
  return sendAsync(dentalLedgerProcessDetail(params), api)
})

// 删除
export const getDentalLedgerDeleteAsync = createAsyncThunk<
  void,
  DentalLedgerDeleteParams,
  RootThunkApi
>('dentalLedgerDeleteAsync', async (params, api) => {
  return sendAsync(dentalLedgerDelete(params), api)
})

//导出
export const getDoctorAuditEntriesListExportAsync = createAsyncThunk<
  void,
  DoctorAuditEntriesParams,
  RootThunkApi
>('doctorAudit/getTransactionQueryExport ', async (params, api) => {
  return sendAsync(getDoctorAuditEntriesListExport(params), api)
})
